// Apolo IDE — ChartRenderer (sprint plan-charts).
//
// Wrapper lazy do recharts: o ChartRendererImpl (que importa recharts) só é
// baixado quando um chart aparece na tela. Suspense com skeleton + aria-label
// resumindo a série (fallback textual = a tabela de dados do bloco).

import { Suspense, lazy } from 'react';

const ChartRendererImpl = lazy(() => import('./ChartRendererImpl.jsx'));

function summarize(type, series) {
  const s = Array.isArray(series) ? series : [];
  const pts = s.reduce((acc, x) => acc + (x.data?.length || 0), 0);
  return `Gráfico ${type} com ${s.length} série(s) e ${pts} pontos`;
}

export default function ChartRenderer({ type = 'line', series = [], height = 240 }) {
  return (
    <div role="img" aria-label={summarize(type, series)} className="h-full w-full">
      <Suspense
        fallback={(
          <div className="flex h-full w-full items-center justify-center">
            <span className="h-5 w-5 animate-spin rounded-full border-2 border-apolo-plan-accent border-t-transparent" aria-hidden="true" />
          </div>
        )}
      >
        <ChartRendererImpl type={type} series={series} height={height} />
      </Suspense>
    </div>
  );
}
